module.exports = __webpack_public_path__ + "static/img/bdc.7253121f.png";